export default {
    numToCapital: numToCapital,
    getPieSum: getPieSum,
    getMaxValue: getMaxValue,
    getDivisor: getDivisor,
    getCurrentYearByMonth: getCurrentYearByMonth,
    getDateLabel: getDateLabel,
    getLastDay: getLastDay,
    getYearly: getYearly
}

function numToCapital(num) {
    if (!num) return '零元整'
    num = num.toFixed(2)
    let strNum = Number((num + '').replace(/[,，]*/g, '')) + '' // 记录字符
    let capitalAr = '零壹贰叁肆伍陆柒捌玖拾'
    let unitAr = ['拾', '佰', '仟', '万', '拾', '佰', '仟', '亿', '拾', '佰', '仟'] // 单位
    let hornStr = ''
    let partStr = ''
    if (strNum.includes('.')) {
        let decimal = strNum.substring(strNum.indexOf('.') + 1)
        console.log(decimal)
        let horn = Number(decimal.charAt(0))
        let part = Number(decimal.charAt(1))
        if (horn !== 0) {
            hornStr = capitalAr.charAt(horn) + '角'
        }
        if (part) {
            partStr = capitalAr.charAt(part) + '分'
        }
    }
    num = parseInt(num) // 转为整数，
    strNum = Number((num + '').replace(/[,，]*/g, '')) + '' // 记录字符
    const resultAr = [] // 记录结果，后边json.in就可
    let index = strNum.length - 1 //记录位数
    let idx = 0 // 记录单位
    let percent = 10
    const turnNum = (num, percent, index) => {
        const unit = num / percent
        const capital = capitalAr[Number(strNum[index])]
        if (unit < 1) {
            resultAr.push(capital)
            // 出现11【一十一】这种情况
            /*if (Number(strNum[index]) === 1 && (strNum.length === 2 || strNum.length === 6 || strNum.length === 10)) {
                resultAr.pop()
            }*/
            return false //结束递归
        } else {
            if (capital === '零') {
                // 万和亿单位不删除
                if (!['万', '亿'].includes(resultAr[resultAr.length - 1])) {
                    resultAr.pop()
                }
                // 前面有零在删掉一个零
                if (resultAr[resultAr.length - 1] === '零') {
                    resultAr.pop()
                }
            }
            resultAr.push(capital)
            // 过滤存在【零万】【零亿】这种情况
            if (['万', '亿'].includes(resultAr[resultAr.length - 2]) && capital === '零') {
                resultAr.pop()
            }
            // 过滤【1亿万】这种情况
            if (resultAr[0] === '万' && resultAr[1] === '亿') {
                resultAr.shift()
            }
            // 末尾【零】删掉
            if (resultAr[0] === '零') {
                resultAr.pop()
            }
            resultAr.push(unitAr[idx++])
            turnNum(num, percent * 10, --index)
        }
    }
    turnNum(num, percent, index)
    let str = resultAr.reverse().join('')
    return str + '元' + hornStr + partStr + '整'
}

function getPieSum(res) {
    let sum = 0
    if (typeof res !== "undefined") {
        res.forEach((item) => {
            if (typeof item !== "undefined") {
                sum += parseFloat(item.value)
            }
        })
    }
    return Number(sum.toFixed(0))
}

function getMaxValue(list1, list2) {
    let max = 0
    let mergedList = list1.concat(list2)
    mergedList.forEach((value) => {
        if (value >= 0) {
            if (value > max) {
                max = value
            }
        }
    })
    return max

}

function getDivisor(res) {

    if (res < 10) {
        return 10
    } else if (res < 50) {
        return 50
    } else {
        return 100
    }
}

function getCurrentYearByMonth() {
    let date = new Date()

    /* if((date.getUTCMonth() + 1) < 4){
         return date.getUTCFullYear() - 1
     }else {
         return  date.getUTCFullYear()
     }*/
    return date.getUTCFullYear()

}

function getDateLabel(res) {
    if (res >= 10) {
        return res.toString();
    } else {
        return '0' + res.toString();
    }
}

function getLastDay(res) {
    if (res.day === "01") {

        if (res.month === "01") {
            res.year = (new Date().getUTCFullYear() - 1).toString()
            res.day = getDateLabel(new Date(res.year, 1, 0).getDate())
            res.month = "12"
        } else {
            res.month = getDateLabel(res.month - 1)
            res.day = getDateLabel(new Date(res.year, res.month, 0).getDate())
        }
    } else {
        res.day = getDateLabel(res.day - 1)
    }
    return res;
}

function getYearly() {
    let date = new Date()

    if ((date.getUTCMonth() + 1) < 4) {
        return date.getUTCFullYear() - 1
    } else {
        return date.getUTCFullYear()
    }
}